// SVGs
import AboutTheGame from './svg/about-the-game.svg';
import BodyBackgound from './svg/bodybackgound.svg';
import CardIcon from './svg/CardIcon.svg';
import CraftIcon from './svg/craftIcon.svg';
import DiamondBoardIcon from './svg/diamond-board.png';
import DiamondIcon from './svg/diamond.svg';
import ErrorIcon from './svg/errorIcon.svg';
import ExchangeIcon from './svg/exchange.svg';
import FacebookIcon from './svg/facebook-icon.svg';
import FinanacialIcon from './svg/finanacialIcon.svg';
import FoodBoardIcon from './svg/food-board.png';
import FoodIcon from './svg/food.svg';
import Footer from './svg/Footer.svg';
import GameBackground from './svg/gameBackground.svg';
import GeneralIcon from './svg/generalIcon.svg';
import GoldBoardIcon from './svg/gold-board.png';
import GoldIcon from './svg/gold.svg';
import HangingBoard from './svg/hanging-board.svg';
import HomeIcon from './svg/homeIcon.svg';
import HomeLogo from './svg/homeLogo.svg';
import HouseIcon from './svg/houseIcon.svg';
import HowToEarnImg from './svg/how-to-earn.svg';
import InstaIcon from './svg/insta-icon.svg';
import LogoutIcon from './svg/logoutIcon.svg';
import Mining from './svg/mining.svg';
import ModalBg from './svg/modalbg.svg';
import MytoolsIcon from './svg/mytoolsIcon.svg';
import Nameplate from './svg/nameplate.svg';
import NavbarBanner from './svg/navbar-banner.svg';
import Note from './svg/note.svg';
import OkBtn from './svg/okBtn.svg';
import PriceBoardIcon from './svg/priceBoard.svg';
import ProfileIcon from './svg/profileIcon.svg';
import PublicFooterLogo from './svg/public-footer-logo.svg';
import RedirectLinkIcon from './svg/redirectLinkIcon.svg';
import TabBg from './svg/tab-bg.svg';
import TitleBoard from './svg/title-board.svg';
import UExchangeIcon from './svg/uexchange.svg';
import VerificationIcon from './svg/verification.svg';
import WalletIcon from './svg/walletIcon.svg';
import WoodBoardIcon from './svg/wood-board.png';
import WoodIcon from './svg/wood.svg';
import XIcon from './svg/x-icon.svg';
import ZogoFarm from './svg/zogo-farm.svg';
// Webp
import AndroidStore from './webp/androidStore.png';
import AppleStore from './webp/appleStore.png';
import BackArrow from './webp/backArrow.webp';
import BottomBanner from './webp/BottomBanner.webp';
import NameBoard from './webp/nameBoard.webp';
import NextArrow from './webp/nextArrow.webp';
import NoticeBoard from './webp/NoticeBoard.webp';
import Play from './webp/Play.webp';
import SwipingBanner from './webp/swiping-banner.webp';

const TopBanner = 'https://d12k9bu1e2n3w5.cloudfront.net/game/topBanner.webp';
const PublicFooterBG = 'https://d12k9bu1e2n3w5.cloudfront.net/game/hangingPadLongHeight.webp';
const LoginBackground = 'https://d12k9bu1e2n3w5.cloudfront.net/game/signup/background.webp';
const GoogleIcon = 'https://d12k9bu1e2n3w5.cloudfront.net/game/signup/google.webp';
const IslandImg = 'https://d12k9bu1e2n3w5.cloudfront.net/game/signup/island.webp';
const SignInViaImg = 'https://d12k9bu1e2n3w5.cloudfront.net/game/signup/signInVia.webp';
export {
  AboutTheGame,
  ZogoFarm,
  Mining,
  NavbarBanner,
  TitleBoard,
  XIcon,
  InstaIcon,
  FacebookIcon,
  GameBackground,
  PriceBoardIcon,
  WoodIcon,
  GoldIcon,
  DiamondIcon,
  ErrorIcon,
  OkBtn,
  ModalBg,
  FoodIcon,
  CardIcon,
  HouseIcon,
  CraftIcon,
  WalletIcon,
  UExchangeIcon,
  ExchangeIcon,
  ProfileIcon,
  MytoolsIcon,
  Note,
  HomeIcon,
  RedirectLinkIcon,
  HomeLogo,
  GeneralIcon,
  VerificationIcon,
  FinanacialIcon,
  HangingBoard,
  Nameplate,
  PublicFooterBG,
  PublicFooterLogo,
  TabBg,
  HowToEarnImg,
  BodyBackgound,
  Footer,
  LoginBackground,
  GoogleIcon,
  IslandImg,
  SignInViaImg,
  BackArrow,
  BottomBanner,
  NameBoard,
  NextArrow,
  NoticeBoard,
  Play,
  SwipingBanner,
  TopBanner,
  LogoutIcon,
  AndroidStore,
  AppleStore,
  DiamondBoardIcon,
  GoldBoardIcon,
  WoodBoardIcon,
  FoodBoardIcon,
};
